import React, { useEffect, useState } from 'react';
import SaveBanner from '../JobDetailPage/Mechanical/SaveBanner';

export default function ShippingSaveBanner({ notification }) {
  const [dismissed, setDismissed] = useState(null);
  useEffect(() => {
    if (!notification || notification.pending) return undefined;
    const timer = setTimeout(() => setDismissed(notification), notification.failed ? 8000 : 3000);
    return () => clearTimeout(timer);
  }, [notification]);
  const visible = Boolean(notification && dismissed !== notification);
  return <div className="shipping-save-banner" role={notification?.failed ? 'alert' : 'status'} aria-live="polite">
    <SaveBanner showNotification={visible} saveStatus={notification?.message || ''} />
  </div>;
}
